import { all, put, select, takeEvery, call } from 'redux-saga/effects';
import { withCursor, selectors } from '../../Stream';
import { createCallbackActionCreator } from '../../Stream/helpers';
import { request } from '../../xhr';
import { initializeStreamAndFetchFirst, fetchNext, getStreamId } from './actionCreators';
function* handleInitializeStreamAndFetchFirst(action) {
    const { deviationId } = action.payload;
    const fetchNextCallback = createCallbackActionCreator(fetchNext.toString());
    yield put(withCursor.actions.initialize({
        streamId: getStreamId(deviationId),
        itemsPerFetch: 25,
        items: [],
        hasMore: true,
        cursor: undefined,
        streamParams: {
            deviationId: deviationId
        },
        fetchNextCallback
    }));
}
function* handleFetchNext(action) {
    const { streamId } = action.payload;
    const { cursor, limit, streamParams } = yield select((state)=>({
            streamParams: selectors.getStreamParams(state, streamId),
            cursor: withCursor.selectors.getCursor(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId)
        }));
    const params = {
        deviationid: streamParams.deviationId,
        cursor,
        limit
    };
    const result = yield call(request, {
        method: 'get',
        url: 'deviation/featured_in_groups',
        params
    }, ()=>{});
    if (result && !result.error) {
        const { results, cursor: nextCursor } = result;
        yield put(withCursor.actions.fetchSuccessDeduped({
            streamId,
            hasMore: nextCursor !== undefined,
            cursor: nextCursor,
            items: results
        }));
    } else {
        var _result;
        yield put(withCursor.actions.fetchFailure({
            streamId,
            errorMsg: `Failed to fetch: ${(_result = result) === null || _result === void 0 ? void 0 : _result.error}`
        }));
    }
}
export default function* rootSaga() {
    yield all([
        takeEvery(initializeStreamAndFetchFirst, handleInitializeStreamAndFetchFirst),
        takeEvery(fetchNext, handleFetchNext)
    ]);
}
